import flatpickr from "flatpickr";
import Iodine from "@caneara/iodine";
import pageOverrides from "../stores/page-overrides";

export default function(identifier = 'basic') {

    return {

        //data
        forceId: '',
        name: '',
        firstName: '',
        lastName: '',
        email: '',
        address: '',
        street: '',
        city: '',
        state: '',
        postalCode: '',
        phone: '',
        productInterest: '',
        appointmentRequest: false,
        preferredTime: '',
        preferredDate: '',
        message: '',
        deliveryType: [],
        nurture: true,
        customerType: '',
        customerLocation: '',
        company: '',
        recaptchaKey: '',
        recaptchaScore: '',

        //tracking
        marketingSource: '',
        formType: 'contact_form',
        channel: '',
        valueTrack: {
            aceId: '',
            adPosition: '',
            adType: '',
            campaignId: '',
            clickId: '',
            creative: '',
            device: '',
            deviceModel: '',
            keyword: '',
            locationInterest: '',
            locationPhysical: '',
            matchType: '',
            network: '',
            param1: '',
            param2: '',
            placement: '',
            productTarget: '',
            random: '',
            target: '',
        },

        //internal
        identifier: identifier,
        layout: 'side-by-side',
        bottledWater: '',
        bottledWaterPreset: null,
        freeWaterTest: null,
        deliveryTypes: ['water', 'salt'],
        customerTypes: {'Existing': 'Current Customer', 'New': 'New Customer'},
        customerLocations: {'residential': 'Home use', 'office': 'Office use'},
        preferredTimes: ['Morning', 'Afternoon'],
        prependMessage: '',
        appendMessage: '',
        dealers: [],
        selectedDealer: null,
        forcedDealer: null,
        iodine: null,
        step: 1,
        waterWorries: [],
        hasLeadInSession: this.$persist(false).using(sessionStorage),
        disclaimer: '',
        pageOverrides: null,
        requireDealerUrl: false,

        //search
        searching: false,
        searched: false,

        //submission
        attemptSubmit: false,
        submitStatus: 'waiting', //waiting, in progress, failure, success
        submitMessage: '',

        //shown fields
        defaultShownFields: {
            name: false,
            firstName: true,
            lastName: true,
            email: true,
            address: true,
            street: false,
            city: false,
            state: false,
            postalCode: true,
            phone: true,
            productInterest: true,
            freeWaterTest: false,
            appointmentRequest: true,
            preferredTime: true,
            preferredDate: true,
            message: true,
            deliveryType: false,
            customerType: false,
            customerLocation: false,
            disclaimer: false,
            company: false,
        },
        customShownFields: {},

        //required fields
        defaultRequiredFields: {
            name: false,
            firstName: true,
            lastName: true,
            email: true,
            address: false,
            street: false,
            city: false,
            state: false,
            postalCode: true,
            phone: true,
            productInterest: true,
            freeWaterTest: false,
            appointmentRequest: false,
            preferredTime: false,
            preferredDate: false,
            message: false,
            deliveryType: false,
            customerType: false,
            customerLocation: false,
            company: false,
        },
        customRequiredFields: {},

        init() {

            if (this.domain().country === 'CA') {
                this.nurture = false;
            }

            if (typeof this.domain().forced_dealer === 'object') {
                this.forcedDealer = this.domain().forced_dealer;
            }

            if (typeof this.domain().form_customization.preferred_times === 'object') {
                this.preferredTimes = this.domain().form_customization.preferred_times;
            }

            if (typeof this.domain().form_customization.disclaimer === 'string') {
                this.disclaimer = this.domain().form_customization.disclaimer;
            }

            if (typeof this.page() !== 'undefined' && typeof(this.page().product_interest) === 'string' && this.identifier !== 'drawer') {
                this.productInterest = this.page().product_interest;
            }

            if (typeof this.promotion() !== 'undefined' && typeof(this.promotion().product_interest) === 'string') {
                this.productInterest = this.promotion().product_interest;
            }

            if (typeof window.recaptchaKey === 'string') {
                this.recaptchaKey = window.recaptchaKey;
            }

            this.initializeCalendar();
            this.setupIodine();
            this.setupPageOverrides();
        },

        updateContact(identifier, shown, required, values) {

            if (identifier === this.identifier || identifier === 'all' || (identifier === 'hidden' && ['modal', 'drawer'].includes(this.identifier))) {
                this.setShown(shown);
                this.setRequired(required);
                this.setValues(values);
            }
        },

        setValues(payload) {
            Object.entries(payload).forEach(([key, value]) => {
                this[key] = value;
            });
        },

        setShown(payload) {
            this.customShownFields = payload;
        },

        setRequired(payload) {
            this.customRequiredFields = payload;
        },

        makeId(id) {
            return this.identifier + '.' + id;
        },

        initializeCalendar() {

            if (this.$refs.preferredDate) {

                flatpickr(this.$refs.preferredDate, {
                    altFormat: 'F j, Y',
                    altInput: true,
                    altInputClass: '',
                    minDate: (new Date).setDate((new Date).getDate() + 2),
                    maxDate: (new Date).setDate((new Date).getDate() + 120),
                    monthSelectorType: 'static',
                    disable: [date =>
                        (date.getMonth() === 0 && date.getDate() === 1) || //new years
                        (date.getMonth() === 4 && date.getDay() === 1 && date.getDate() >= 25) || //memorial day
                        (date.getMonth() === 6 && date.getDate() === 4) || //july 4th
                        (date.getMonth() === 8 && date.getDay() === 1 && date.getDate() >= 1 && date.getDate() <= 7) || //labor day
                        (date.getMonth() === 10 && date.getDay() === 4 && date.getDate() >= 22 && date.getDate() <= 28) || //thanksgiving
                        (date.getMonth() === 10 && date.getDay() === 5 &&  date.getDate() >= 23 && date.getDate() <= 29) || //day after thanksgiving
                        (date.getMonth() === 11 && date.getDate() === 25) || //christmas
                        date.getDay() === 0 || date.getDay() === 6],
                    static: true,
                    dateFormat: 'Y-m-d',
                });
            }
        },

        initializeNameWatcher() {

            this.$watch('name', (newValue) => {
                if (newValue.includes(' ')) {
                    this.firstName = newValue.split(' ').slice(0, -1).join(' ');
                    this.lastName = newValue.split(' ').slice(-1).join(' ');
                } else {
                    this.firstName = newValue;
                }
            });
        },

        submitForm() {

            this.attemptSubmit = true;

            if (this.formValidation()) {

                this.submitLead();

                //disable default
                return false;
            }
        },

        submitFirstStep() {

            this.attemptSubmit = true;

            //remove only step 2 fields
            let temp = this.requiredFields();
            const savedTime = temp['preferredTime'];
            const savedDate = temp['preferredDate'];
            temp['preferredTime'] = false;
            temp['preferredDate'] = false;
            this.setRequired(temp);

            if (this.formValidation()) {
                //re-add step 2 fields
                temp['preferredTime'] = savedTime;
                temp['preferredDate'] = savedDate;
                this.setRequired(temp);

                this.attemptSubmit = false;
                this.step++;
            }
        },

        async submitPromoStep1() {

            this.attemptSubmit = true;

            if (this.fieldValidation('postalCode').valid) {

                await this.searchDealers();

                this.attemptSubmit = false;

                if (this.showNoDealers()) {
                    return;
                }

                this.step++;

                if (this.$refs.name !== undefined) {
                    this.$nextTick(() => {
                        this.$refs.name.focus();
                    });
                }
            }
        },

        submitPromo() {

            this.attemptSubmit = true;

            if (this.formValidation()) {

                this.submitLead()
                    .then(() => {

                        if (this.submitStatus === 'success' || this.submitStatus === 'recaptcha_failure') {
                            this.step++;
                        }
                    });
            }
        },

        async submitLead() {

            //only allow one submission at once
            if (this.submitStatus === 'in progress') {
                return;
            }

            //start submission
            this.submitStatus = 'in progress';

            //format message
            let finalMessage = this.message;
            finalMessage = (this.prependMessage !== '') ? this.prependMessage + "\r\n\r\n" + finalMessage : finalMessage;
            finalMessage = (this.appendMessage !== '') ? finalMessage + "\r\n\r\n" + this.appendMessage : finalMessage;

            //extra data
            if (this.waterWorries.length > 0) {
                finalMessage = finalMessage + '\r\n\r\n' + 'Water Worries: ' + this.waterWorries.join(', ');
            }

            if (this.shownFields().customerType) {
                finalMessage = finalMessage + '\r\n\r\n' + 'Customer Type: ' + this.customerType;
            }

            if (this.shownFields().customerLocation) {
                finalMessage = finalMessage + '\r\n\r\n' + 'Home or office use: ' + this.customerLocation;
            }

            if (this.shownFields().company) {
                finalMessage = finalMessage + '\r\n\r\n' + 'Company name: ' + this.company;
            }

            //additional comments
            if (this.selectedDealer.id == 1505) {
                finalMessage = finalMessage + '\r\n\r\n' + 'This is a Woodstock lead';
            }

            try {
                const token = await new Promise((resolve, reject) => {
                    grecaptcha.ready(() => {
                        grecaptcha.execute(this.recaptchaKey, { action: 'submit' })
                            .then(resolve)
                            .catch(reject);
                    });
                });
        
                const recaptchaResponse = await axios.post('/api/v1/recaptcha', { clientToken: token });

                this.recaptchaScore = recaptchaResponse.data.score.toString();
        
                if (recaptchaResponse.status !== 200) {
                    throw new Error('Recaptcha failed');
                }
            } catch (e) {
                //call to spam log
                await axios.get('/api/v1/spam', {
                    params: {
                        email: this.email,
                        phone: this.phone,
                        checkSource: 'reCaptcha failure',
                        channel: this.channel,
                        url: window.location.href,
                        message: this.message,
                        recaptchaScore: (this.recaptchaScore === '' ? e.response?.data?.score : this.recaptchaScore),
                    },
                })
                this.submitStatus = 'recaptcha_failure';
                this.submitMessage = 'Recaptcha failure';
                this.hasLeadInSession = true;
                return;
            }

            //submit to API
            return axios.post('/api/v1/leads', {
                url_page: window.location.href,
                dealer_id: this.forcedDealer !== null ? this.forcedDealer.id : this.selectedDealer.id,
                domain_id: this.domain().id,
                force_id: this.forcedDealer !== null ? this.forcedDealer.culligan_corporate_id : this.selectedDealer.culligan_corporate_id,
                first_name: this.firstName,
                last_name: this.lastName,
                email: this.email,
                street: this.street ? this.street : this.address,
                city: this.city,
                state: this.state,
                postal_code: this.postalCode,
                phone: this.phone,
                product_interest: this.productInterest,
                message: finalMessage,
                channel: this.channel,
                vt_ace_id: this.valueTrack.aceId,
                vt_ad_position: this.valueTrack.adPosition,
                vt_ad_type: this.valueTrack.adType,
                vt_campaign_id: this.valueTrack.campaignId,
                vt_click_id: this.valueTrack.clickId,
                vt_creative: this.valueTrack.creative,
                vt_device: this.valueTrack.device,
                vt_device_model: this.valueTrack.deviceModel,
                vt_keyword: this.valueTrack.keyword,
                vt_location_interest: this.valueTrack.locationInterest,
                vt_location_physical: this.valueTrack.locationPhysical,
                vt_match_type: this.valueTrack.matchType,
                vt_network: this.valueTrack.network,
                vt_param_1: this.valueTrack.param1,
                vt_param_2: this.valueTrack.param2,
                vt_placement: this.valueTrack.placement,
                vt_product_target: this.valueTrack.productTarget,
                vt_random: this.valueTrack.random,
                vt_target: this.valueTrack.target,
                appointment_request: this.appointmentRequest ? this.preferredDate : '',
                appointment_request_time: this.appointmentRequest ? this.preferredTime : '',
                marketing_source: this.marketingSource,
                form_type: this.formType,
                bottled_water: this.bottledWater,
                free_water_test: this.freeWaterTest,
                template: 'web',
                customer_type: this.customerType,
                category: this.customerLocation,
                recaptcha_score: this.recaptchaScore,
            })
                .then(response => {
                    this.submitStatus = 'success';
                    this.submitMessage = 'Successfully submitted lead.';
                    this.hasLeadInSession = true;

                    if (response.data.message.includes('Sender email or message tagged as spam')) {
                        return
                    }

                    if (typeof window.fbq === 'function' && response.data.klid) {
                        window.fbq('trackSingle', '1117998811575937', 'Lead', {
                            content_name: 'Form Submission',
                            klid: response.data.klid,
                            duplicate: response.data.duplicate,
                        });
                    }

                    if (typeof window.ga === 'function' && response.data.klid) {
                        window.ga('send', 'pageview', '/leads/success');
                    }

                    if (typeof window.gtag === 'function' && response.data.klid) {
                        window.gtag('event', 'Lead Submission', {
                            klid: response.data.klid,
                            duplicate: response.data.duplicate,
                        });
                    }

                    if (typeof window.pintrk === 'function' && response.data.klid) {
                        window.pintrk('track', 'lead', {
                            klid: response.data.klid,
                            duplicate: response.data.duplicate,
                        });
                    }

                    if (typeof window.lintrk === 'function' && response.data.klid) {
                        window.lintrk('track', { conversion_id: 19220100 });
                    }

                    if (typeof window.ndp === 'function' && response.data.klid) {
                        window.ndp('track', 'CONVERSION', {
                            klid: response.data.klid,
                            duplicate: response.data.duplicate,
                        });
                    }

                    if (typeof adroll !== 'undefined' && typeof adroll.track === 'function' && response.data.klid) {
                        adroll.track("pageView", {
                            segment_name: "5f643461"
                        });
                    }

                    if (typeof window.saq === 'function' && response.data.klid && ['PMax', 'native'].includes(this.channel)) {
                        window.saq('conv', 'C4Z15V2SAK5MuiUj8u8Dzx');
                    }

                    if (typeof window.formSubmitted === 'function') {
                        window.formSubmitted();
                    }

                })
                .catch(error => {
                    this.submitStatus = 'failure';
                    this.submitMessage = error.response.data.message ?? 'Unable to submit lead. Please try again.';
                });
        },

        resetForm() {

            //empty the data fields
            this.forceId = '';
            this.name = '';
            this.firstName = '';
            this.lastName = '';
            this.email = '';
            this.street = '';
            this.city = '';
            this.state = '';
            this.postalCode = '';
            this.phone = '';
            this.productInterest = '';
            this.appointmentRequest = false;
            this.preferredTime = '';
            this.preferredDate = '';
            this.deliveryType = [];
            this.customerType = [];
            this.customerLocation = [];
            this.message = '';
            this.bottledWater = '';
            this.dealers = [];
            this.selectedDealer = null;
            this.searched = false;
            this.attemptSubmit = false;
        },

        updateBottledWaterInterest(interest) {
            this.bottledWater = interest;

            //auto select
            if (this.filteredDealers().length === 1) {
                this.selectDealer(this.filteredDealers()[0]);
            }
        },

        selectDealer(dealer) {
            this.selectedDealer = dealer;
        },

        setDealerInSession() {
            //send request
            axios.post('/api/v1/update-session-dealer', {
                dealer: this.selectedDealer.id,
            })
            .then(response => {
                if (!window.location.pathname.includes('/' + this.selectedDealer.id)) {
                    let result = window.location.pathname.replace(/^\/locations\/[^\/]+\/\d+\/?/, '');
                    window.location.pathname = result;
                }
                else {
                    location.reload();
                }
            })
            .catch(error => console.error('Error:', error));

        },

        searchDealers() {

            //do not search if we have a forced dealer
            if (this.forcedDealer !== null && !this.requireDealerUrl) {
                return;
            }

            //reset search state
            this.bottledWater = '';
            this.selectedDealer = null;
            this.dealers = [];

            //start search
            this.searching = true;

            //call to dealer locator api
            return axios.get('/api/v1/locator', {
                params: {
                    pc: this.postalCode,
                    bw: ['yes', 'no'].includes(this.bottledWaterPreset) ? this.bottledWaterPreset : null,
                    kc: true,
                    url: this.requireDealerUrl ? window.location.href : null,
                },
            })
                .then(response => {

                    //add the results to our available dealers
                    this.dealers = response.data;

                    //if we only get 1 dealer back, we'll autoselect it for the user
                    if (this.dealers.length === 1) {
                        this.selectDealer(this.dealers[0]);
                    }
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {

                    //
                    this.searching = false;
                    this.searched = true;
                });
        },

        logClickToCorporate() {
            //call to nonKennedy log
            axios.get('/api/v1/nonKennedy', {
                params: {
                    pc: this.postalCode,
                    url: window.location.href,
                },
            })
                .catch(error => {
                    console.log(error);
                });
        },

        selectDeliveryType(value) {
            this.isDeliveryTypeSelected(value) ? this.deliveryType.splice(this.deliveryType.indexOf(value), 1) : this.deliveryType.push(value);
        },

        isDeliveryTypeSelected(value) {
            return this.deliveryType.includes(value);
        },

        isCustomerTypeSelected(value) {
            return this.customerType.includes(value);
        },

        isCustomerLocationSelected(value) {
            return this.customerLocation.includes(value);
        },

        loadPaidSearchData(paidSearch) {
            if (paidSearch && typeof paidSearch === 'object') {
                this.channel = paidSearch.channel;
                this.valueTrack.aceId = paidSearch.google_ace_id;
                this.valueTrack.adPosition = paidSearch.google_ad_position;
                this.valueTrack.adType = paidSearch.google_ad_type;
                this.valueTrack.campaignId = paidSearch.google_campaign_id;
                this.valueTrack.clickId = paidSearch.google_click_id;
                this.valueTrack.creative = paidSearch.google_creative;
                this.valueTrack.device = paidSearch.google_device;
                this.valueTrack.deviceModel = paidSearch.google_device_model;
                this.valueTrack.keyword = paidSearch.google_keyword;
                this.valueTrack.locationInterest = paidSearch.google_location_interest;
                this.valueTrack.locationPhysical = paidSearch.google_location_physical;
                this.valueTrack.matchType = paidSearch.google_match_type;
                this.valueTrack.network = paidSearch.google_network;
                this.valueTrack.param1 = paidSearch.google_param_1;
                this.valueTrack.param2 = paidSearch.google_param_2;
                this.valueTrack.placement = paidSearch.google_placement;
                this.valueTrack.productTarget = paidSearch.google_product_target;
                this.valueTrack.random = paidSearch.google_random;
                this.valueTrack.target = paidSearch.google_target;
            }
        },

        domain() {
            return window.domain;
        },

        page() {
            return window.page;
        },

        promotion() {
            return window.promotion;
        },

        shownFields() {

            let temp = {
                ...this.defaultShownFields,
                ...this.customShownFields,
            };

            if (this.appointmentRequest && this.domain().form_customization.require_address_with_appointment) {
                temp[this.promotion() === undefined ? 'address' : 'street'] = true;
            }

            if (typeof this.domain().form_customization.disclaimer === 'string') {
                temp.disclaimer = true;
            }

            // if not promo page add domain specific changes
            if (typeof this.promotion() === 'undefined') {

                if (this.domain().form_customization.customer_type) {
                    temp.customerType = true;
                }

                if (this.domain().form_customization.customer_location) {
                    temp.customerLocation = true;
                }

                if (typeof this.page() !== 'undefined' && typeof (this.page().product_interest) === 'string' && this.identifier !== 'drawer') {
                    temp.productInterest = false;
                }
            }

            temp = this.pageOverrides.setShown(this.page().override, temp);

            return temp;
        },

        requiredFields() {

            let appointmentFields = {
                preferredDate: this.appointmentRequest,
                preferredTime: this.appointmentRequest,
            }

            let temp = {
                ...this.defaultRequiredFields,
                ...appointmentFields,
                ...this.customRequiredFields
            };

            if (this.appointmentRequest && this.domain().form_customization.require_address_with_appointment) {
                temp[this.promotion() === undefined ? 'address' : 'street'] = true;
            }

            // if not promo page add domain specific changes
            if (typeof this.promotion() === 'undefined') {

                if (this.domain().form_customization.customer_type) {
                    temp.customerType = true;
                }

                if (this.domain().form_customization.customer_location) {
                    temp.customerLocation = true;
                }
            }

            temp = this.pageOverrides.setRequired(this.page().override, temp);

            return temp;
        },

        showBottledWaterInterest() {
            return this.dealers.length > 1 && !this.bottledWater && this.dealers.some(function (dealer) {
                return (dealer.services_inclusive && dealer.services_inclusive.includes('bottled_water'))
                    || (dealer.services_exclusive && dealer.services_exclusive.includes('bottled_water'));
            });
        },

        showDealerSelect() {
            return this.searched && !this.searching && this.dealers.length > 1 && !this.showBottledWaterInterest() && !this.selectedDealer;
        },

        showNoDealers() {
            return this.searched && !this.searching && this.dealers.length === 0;
        },

        showNurture() {
            return this.domain().country === 'CA';
        },

        postalCodeName() {
            return this.domain().country === 'CA' ? 'Postal code' : 'Zip code';
        },

        stateName() {
            return this.domain().country === 'CA' ? 'Province' : 'State';
        },

        filteredDealers() {

            //remove 'exclusive'
            if (this.bottledWater === 'yes') {
                return this.dealers.filter(function (dealer) {
                    return !(dealer.services_exclusive && dealer.services_exclusive.includes('bottled_water'));
                });
            }

            //remove inclusive
            else if (this.bottledWater === 'no') {
                return this.dealers.filter(function (dealer) {
                    return !(dealer.services_inclusive && dealer.services_inclusive.includes('bottled_water'));
                });
            }

            //all dealers
            return this.dealers;
        },

        shortenedProductInterest() {
            switch (this.productInterest) {
                case 'bottled_water':
                    return 'BW';
                case 'commercial_and_industrial':
                    return 'CI';
                case 'drinking_water_system':
                    return 'DW';
                default:
                    return '';
            }
        },

        setupIodine() {
            this.iodine = new Iodine();
        },

        setupPageOverrides() {
            this.pageOverrides = new pageOverrides();
            this.setValues(this.pageOverrides.setValues(this.page().override));
        },

        validationClass(field) {
            return this.attemptSubmit ? (this.fieldValidation(field).valid ? 'is-valid' : 'is-invalid') : '';
        },

        showValidation(field) {
            return this.attemptSubmit && !this.fieldValidation(field).valid;
        },

        fieldValidation(field) {
            return this.iodine.assert(this[field], this.validationRules(field));
        },

        formValidation() {

            let fields = [
                'name',
                'firstName',
                'lastName',
                'street',
                'city',
                'state',
                'postalCode',
                'selectedDealer',
                'phone',
                'email',
                'nurture',
                'productInterest',
                'freeWaterTest',
                'message',
                'deliveryType',
                'customerType',
                'customerLocation',
                'company',
                'preferredTime',
                'preferredDate',
            ];

            return fields.every((field) => this.fieldValidation(field).valid);
        },

        validationRules(field) {

            return {
                name: [
                    this.shownFields().name && this.requiredFields().name ? 'required' : 'optional',
                    'minLength:2',
                    'maxLength:255',
                ],
                firstName: [
                    this.shownFields().firstName && this.requiredFields().firstName ? 'required' : 'optional',
                    'minLength:2',
                    'maxLength:50',
                ],
                lastName: [
                    this.shownFields().lastName && this.requiredFields().lastName ? 'required' : 'optional',
                    'minLength:2',
                    'maxLength:50',
                ],
                address: [
                    this.shownFields().address && this.requiredFields().address ? 'required' : 'optional',
                    'minLength:2',
                    'maxLength:255',
                ],
                street: [
                    this.shownFields().street && this.requiredFields().street ? 'required' : 'optional',
                    'minLength:2',
                    'maxLength:255',
                ],
                city: [
                    this.shownFields().city && this.requiredFields().city ? 'required' : 'optional',
                    'minLength:2',
                    'maxLength:255',
                ],
                state: [
                    this.shownFields().state && this.requiredFields().state ? 'required' : 'optional',
                    'minLength:2',
                    'maxLength:255',
                ],
                postalCode: [
                    this.shownFields().postalCode && this.requiredFields().postalCode ? 'required' : 'optional',
                    'minLength:5',
                    'maxLength:7',
                ],
                selectedDealer: [
                    this.forcedDealer === null ? 'required' : 'optional',
                ],
                phone: [
                    this.shownFields().phone && this.requiredFields().phone ? 'required' : 'optional',
                    'minLength:9',
                    {
                        rule: 'regexMatch',
                        param: /^(\+?1-?)?(\([2-9]([02-9]\d|1[02-9])\)|[2-9]([02-9]\d|1[02-9]))-?[2-9]([02-9]\d|1[02-9])-?\d{4}$/,
                    },
                ],
                email: [
                    this.shownFields().email && this.requiredFields().email ? 'required' : 'optional',
                    'email',
                ],
                nurture: [
                    this.showNurture() ? {
                        rule: 'in',
                        param: [false, true, 0, 1],
                    } : null,
                ].filter(item => Boolean(item)),
                productInterest: [
                    this.shownFields().productInterest && this.requiredFields().productInterest ? 'required' : 'optional',
                ],
                freeWaterTest: [
                    this.shownFields().freeWaterTest && this.requiredFields().freeWaterTest ? 'required' : 'optional',
                ],
                message: [
                    this.shownFields().message && this.requiredFields().message ? 'required' : 'optional',
                    'maxLength:500',
                ],
                deliveryType: [
                    this.shownFields().deliveryType && this.requiredFields().deliveryType ? 'required' : 'optional',
                ],
                customerType: [
                    this.shownFields().customerType && this.requiredFields().customerType ? {
                        rule: 'in',
                        param: Object.keys(this.customerTypes),
                    } : 'optional',
                ],
                customerLocation: [
                    this.shownFields().customerLocation && this.requiredFields().customerLocation ? {
                        rule: 'in',
                        param: Object.keys(this.customerLocations),
                    } : 'optional',
                ],
                company: [
                    this.shownFields().company && this.requiredFields().company ? 'required' : 'optional',
                    'minLength:2',
                    'maxLength:255',
                ],
                preferredTime: [
                    this.shownFields().preferredTime && this.requiredFields().preferredTime ? 'required' : 'optional',
                ],
                preferredDate: [
                    this.shownFields().preferredDate && this.requiredFields().preferredDate ? 'required' : 'optional',
                ],
            }[field] ?? [];
        },

        submitOnExit(){
            window.addEventListener('beforeunload', (event) => {
                //remove only step 2 fields
                let temp = this.requiredFields();
                temp['preferredTime'] = false;
                temp['preferredDate'] = false;
                this.setRequired(temp);

                if (this.formValidation() && !this.attemptSubmit) {
                    this.submitLead();
                }
            });
        },

        initAutocomplete(){
            let autocomplete = new google.maps.places.Autocomplete(
                document.getElementById(this.identifier + '.address'),
                {
                    types: ['address'],
                    componentRestrictions: {'country': ['US', 'CA']},
                    fields: ['place_id', 'address_components', 'geometry', 'name']
                }
            );

            let temp = this;

            autocomplete.addListener('place_changed', function(){
                let place = this.getPlace();

                temp.street = '';
                temp.postalCode = '';
                temp.city = '';
                temp.state = '';

                for (let component of place.address_components) {
                    let componentType = component.types[0];
                    switch (componentType) {
                        case "street_number": temp.street = component.long_name; break;
                        case "route": temp.street += ' ' + component.short_name; break;
                        case "postal_code": temp.postalCode = component.long_name; break;
                        case "locality": temp.city = component.long_name; break;
                        case "administrative_area_level_1": temp.state = component.short_name; break;
                    }
                }

                temp.searchDealers();

            });

            // Clear fields if input is empty
            document.getElementById(this.identifier + '.address').addEventListener('input', function () {
                if (this.value.trim() === '') {
                    temp.street = '';
                    temp.city = '';
                    temp.state = '';
                }
            });
        },

    }
}
